import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useMemo } from 'react'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import without from 'lodash/without';
import classes from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';
import InputGroup, { shouldRenderInputGroup } from '@nerdwallet/react-input-group';
import { useId } from '@nerdwallet/react-accessibility';
import CheckboxOption from './checkbox-option';
/**
 * Determine if an option is checked given the option's value and the current
 * group value.
 */

var isChecked = function isChecked(currentGroupValue, optionValue) {
  if (currentGroupValue == null) {
    return undefined;
  }

  if (Array.isArray(currentGroupValue)) {
    return currentGroupValue.indexOf(optionValue) !== -1;
  }

  return currentGroupValue === optionValue;
};
/**
 * Add a new selected checkbox value to an group value. Group values can be
 * represented by arrays (because multiple checkboxes can be selected a time)
 * or by a single value (for convenience).
 */


var appendValue = function appendValue(currentGroupValue, optionValue) {
  if (isChecked(currentGroupValue, optionValue)) {
    return currentGroupValue;
  }

  if (currentGroupValue == null) {
    return [optionValue];
  }

  if (Array.isArray(currentGroupValue)) {
    return [].concat(_toConsumableArray(currentGroupValue), [optionValue]);
  }

  return [currentGroupValue, optionValue];
};
/**
 * Add a new selected checkbox value to an group value. Group values can be
 * represented by arrays (because multiple checkboxes can be selected a time)
 * or by a single value (for convenience).
 */


var removeValue = function removeValue(currentGroupValue, optionValue) {
  if (!isChecked(currentGroupValue, optionValue)) {
    return currentGroupValue;
  }

  if (Array.isArray(currentGroupValue)) {
    return without(currentGroupValue, optionValue);
  }

  return [];
};
/**
 * Util that determines whether the CheckboxOption is disabled, based on the
 * precedence of
 *
 * 1) if disabled is supplied at the top level of the CheckboxGroup, else
 * 2) if the individual CheckboxOption is marked as disabeld, through options.disabled
 */


var isDisabled = function isDisabled(disabledGroup, disabledOption) {
  return disabledGroup || disabledOption;
};
/**
 * A high-level input with an API similar to `<Select>` that takes multiple
 * options and renders multiple checkboxes.
 */


var CheckboxGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var alignCheckboxTop = props.alignCheckboxTop,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      inline = props.inline,
      nameProp = props.name,
      onChange = props.onChange,
      options = props.options,
      value = props.value,
      label = props.label,
      helpMessage = props.helpMessage,
      error = props.error,
      errorMessage = props.errorMessage,
      tooltip = props.tooltip,
      tooltipPlacement = props.tooltipPlacement,
      otherProps = _objectWithoutProperties(props, ["alignCheckboxTop", "className", "defaultValue", "disabled", "inline", "name", "onChange", "options", "value", "label", "helpMessage", "error", "errorMessage", "tooltip", "tooltipPlacement"]); // `name` is used to link related radio buttons together for keyboard
  // navigation. If the name isn't provided, we can use `useId()` to generate
  // one, since it doesn't really matter what the name is as long as it's a
  // globally-unique string.


  var name = useId(nameProp);
  var id = useId();
  var errorMessageId = "".concat(id, "-error-message");
  var helpMessageId = "".concat(id, "-help-message"); // It's safe to unconditionally render both IDs in `aria-describedby`, even
  // if there isn't a help/error message currently being shown. If
  // `aria-describedby` refers to an element that doesn't exist, it just skips it.

  var ariaDescribedByIds = "".concat(errorMessageId, " ").concat(helpMessageId);
  var changeHandlers = useMemo(function () {
    var newChangeHandlers = {};
    options.forEach(function (option) {
      newChangeHandlers[option.value] = function (event) {
        event.stopPropagation();
        onChange({
          target: {
            value: event.target.checked ? appendValue(value, option.value) : removeValue(value, option.value)
          }
        });
      };
    });
    return newChangeHandlers;
  }, [options, value, onChange]);
  var willRenderInputGroup = shouldRenderInputGroup(props);
  var marginClassName = inline ? 'margin-right-3' : 'margin-bottom-2';
  var group = /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(_defineProperty({}, className, className && !willRenderInputGroup)),
    ref: ref
  }, otherProps), options.map(function (option, i) {
    return /*#__PURE__*/React.createElement(CheckboxOption, {
      alignCheckboxTop: alignCheckboxTop,
      "aria-describedby": ariaDescribedByIds,
      checked: isChecked(value, option.value),
      className: classNames(_defineProperty({}, classes(marginClassName), i !== options.length - 1)),
      defaultChecked: isChecked(defaultValue, option.value),
      disabled: isDisabled(disabled, option.disabled),
      inline: inline,
      key: option.value,
      label: option.label,
      name: name,
      onChange: changeHandlers[option.value]
    });
  }));

  if (!willRenderInputGroup) {
    return group;
  }

  return /*#__PURE__*/React.createElement(InputGroup, {
    className: className,
    disabled: disabled,
    error: error,
    errorMessage: errorMessage,
    errorMessageId: errorMessageId,
    fieldset: true,
    helpMessage: helpMessage,
    helpMessageId: helpMessageId,
    input: group,
    label: label,
    tooltip: tooltip,
    tooltipPlacement: tooltipPlacement
  });
});
CheckboxGroup.displayName = 'CheckboxGroup'; // Hint to InputGroup and other consumers that a <fieldset> should be used.

CheckboxGroup.shouldUseFieldset = true;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  CheckboxGroup.propTypes = {
    /** A list of checkbox options (value, label, and if disabled or not). */
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      disabled: PropTypes.bool
    })).isRequired,

    /** The currently selected value(s). */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

    /** Callback to be called when the selected value(s) change. */
    onChange: PropTypes.func,

    /**
     * Whether options should be rendered inline on one line (block by
     * default). This should only be used when there are only two simple
     * options (like "Yes" and "No").
     */
    inline: PropTypes.bool,

    /** Name attribute for <input> elements. */
    name: PropTypes.string,

    /** Initial value when state is uncontrolled. */
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

    /** Flag to indicate if the entire checkbox group should be selectable */
    disabled: PropTypes.bool,

    /** Show the checkbox group in an error visual state. */
    error: PropTypes.bool,

    /** Optional label for the checkbox group. */
    label: PropTypes.string,

    /** Boolean flag to top-align the checkbox when the checkbox text spans multiple lines. */
    alignCheckboxTop: PropTypes.bool,

    /** Optional text to be shown indicating the user is in an error state. */
    errorMessage: PropTypes.node,

    /** Optional help text shown below the checkbox group. */
    helpMessage: PropTypes.node,

    /** Optional tooltip shown via an icon next to the label. */
    tooltip: PropTypes.node,

    /** Positioning of tooltip. */
    tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

    /** Classes to add to the containing element. */
    className: PropTypes.string
  };
}

CheckboxGroup.defaultProps = {
  alignCheckboxTop: false,
  className: null,
  defaultValue: null,
  disabled: false,
  error: null,
  errorMessage: null,
  helpMessage: null,
  inline: false,
  label: null,
  name: null,
  onChange: function onChange(f) {
    return f;
  },
  tooltip: null,
  tooltipPlacement: null,
  value: null
};
export default CheckboxGroup;